import { render, staticRenderFns } from "./tablaGrupos.vue?vue&type=template&id=02580a49&scoped=true&"
import script from "./tablaGrupos.vue?vue&type=script&lang=js&"
export * from "./tablaGrupos.vue?vue&type=script&lang=js&"
import style0 from "./tablaGrupos.vue?vue&type=style&index=0&id=02580a49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02580a49",
  null
  
)

export default component.exports